import React, {ChangeEvent, useEffect, useRef, useState} from "react";

import AppIcon from "src/commun/composants/AppIcon";
import useNoAffilieFormatter from "src/commun/hooks/useNoAffilieFormatter";
import AppRecherche from "src/commun/composants/AppRecherche/AppRecherche";
import {Employeur} from "src/domain/Employeur";
import styles from "./MenuSelectionAffilie.scss";
import {useAppState} from "src/app/state/StateProvider";
import AppBouton from "src/commun/composants/formulaire/AppBouton";
import {useLocation, useNavigate} from "react-router-dom";


export type MenuSelectionAffilieProps = {
    affilies: Employeur[] | undefined;
};

const MenuSelectionAffilie = ({
                                  affilies,
                              }: MenuSelectionAffilieProps) => {

    const [state, dispatch] = useAppState();
    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false);
    const [aPlusDe1AffilieAutorise, setAPlusDe1AffilieAutorise] = useState(false);
    const [passeportsFiltres, setPasseportsFiltres] = useState(affilies);
    const divRef = useRef<HTMLDivElement>(null);

    const { noAffilieFormat } = useNoAffilieFormatter();

    useEffect(() => {
        // set automatique de l'affilié si unique
        if (affilies && affilies.length >= 1) {
            if (affilies.length === 1) {
                setAPlusDe1AffilieAutorise(false);
                fetchAndSetInContextEmployeur(affilies[0]);
            } else if (affilies.length > 1) {
                fetchAndSetInContextEmployeur(state.employeurContextuel || affilies[0]);
                setAPlusDe1AffilieAutorise(true);
                setPasseportsFiltres(affilies);
            }
        }
    }, [affilies, state.employeurContextuel]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (divRef.current && !divRef.current.contains(event.target as Node)) {
                if (setIsOpen) {
                    setIsOpen(false);
                }
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            setPasseportsFiltres(affilies);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, divRef, affilies, setIsOpen]);

    const toggleRechercheActive = () => {
        setIsOpen((precValue) => !precValue);
    };

    const fetchAndSetInContextEmployeur = (employeur: Employeur) => {
        dispatch({type: "setEmployeurContextuel", payload: employeur});

        // Update URL
        const locationSearch = new URLSearchParams(location.search);
        locationSearch.set("uuidEmployeur", employeur.uuidEmployeur);
        locationSearch.set("noTiers", employeur.noTiers);

        const to = {pathname: location.pathname, search: locationSearch.toString()};
        navigate(to, {replace: true});
    };

    const selectAffilieHandler = (employeur: Employeur) => {
        fetchAndSetInContextEmployeur(employeur);
        if (setIsOpen) {
            setIsOpen(false);
        }
    };

    const search = (passeport: Employeur, searchedValue: string) =>
        (
            passeport.nomEmployeur.toLowerCase().trim().includes(searchedValue) ||
            passeport.noEmployeur.trim().replace(/^0|[.-]/g, "").includes(searchedValue.replace(/^0|[.-]/g, ""))
        )
        ||
        (
            (passeport.nomEmployeur === undefined || passeport.nomEmployeur.length == 0)
            &&
            (
                passeport.nomTiers.toLowerCase().trim().includes(searchedValue) ||
                passeport.noTiers.toLowerCase().trim().includes(searchedValue)
            )
        )

    ;


    const filterAffilies = (searchedValue: string) => {
        const seachedValueLowerCase = searchedValue.toLowerCase().trim();

        return JSON.parse(JSON.stringify(affilies)).filter(
            (affilie: Employeur) => search(affilie, seachedValueLowerCase)
        )
    }

    const displayLigne = (affilie: Employeur, index: number) => {
        return (
            <div key={(affilie.noEmployeur || affilie.noTiers) + index} className={styles.choixPopupAffilies}>
                <div
                    className={styles.selection}
                    onClick={() => {
                        selectAffilieHandler(affilie);
                    }}
                >

                    <div className={styles.choixPopupNo}>
                        <div
                            className={styles.choixPopupNoAffilie}>{affilie.noEmployeur && noAffilieFormat(affilie.noEmployeur)}</div>
                    </div>
                    <div
                        className={styles.choixPopupRaisonSociale}>{affilie.noEmployeur ? affilie.nomEmployeur : affilie.nomTiers}</div>
                </div>
            </div>
        )
    }

    return affilies && affilies.length > 0 ? (
        <>
            <div className={styles.boutonAffilie}>
                <AppBouton
                    id="BoutonMenuAffilie"
                    typeBouton="PRIMAIRE"
                    className={`${state.employeurContextuel ? styles.boutonAffilieSelectionne : styles.boutonSelectionne} ${!aPlusDe1AffilieAutorise && styles.boutonAffilieDisablePointer}`}
                    onClick={() => aPlusDe1AffilieAutorise && toggleRechercheActive()}
                >
                    <div className={styles.affilieTailleBouton}>
            <span className={styles.affilieSelectionne}>
              {state.employeurContextuel?.noEmployeur ? <>{noAffilieFormat(state.employeurContextuel?.noEmployeur)} - {state.employeurContextuel?.nomEmployeur}</> : <>{state.employeurContextuel?.nomTiers}</>}
            </span>
                        <AppIcon name="bas" size="22px" className={styles.iconFlecheBas}/>
                    </div>
                </AppBouton>
            </div>
            <div className={`${styles.fondBleu} ${isOpen && styles.ouvert}`} ref={divRef}>
                {isOpen && (
                    <div className={styles.choixPopup}>
            <span className={styles.searchContainer}>
              <AppRecherche
                  name={"rechercherAffilie"}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                      setPasseportsFiltres(filterAffilies(event.target.value))
                  }
              />
            </span>

                        {passeportsFiltres!.map((passeport, index) => displayLigne(passeport, index))}
                    </div>
                )}
            </div>
        </>
    ) : (
        <></>
    );
};

export default MenuSelectionAffilie;
